import React, { useState, useEffect } from "react";

/**
 * Lightweight, high-performance LoadingScreen.
 * Features a minimalist 3D-styled SVG Rudraksh bead, spinning using pure CSS.
 * NO heavy external imaging or JS animation libraries like framer-motion are used.
 */
const LoadingScreen = ({ visible }) => {
  const [shouldRender, setShouldRender] = useState(visible);

  useEffect(() => {
    if (visible) setShouldRender(true);
    let timer;
    if (!visible) {
      // Allow 800ms for the fade-out CSS transition to complete before unmounting
      timer = setTimeout(() => setShouldRender(false), 800);
    }
    return () => clearTimeout(timer);
  }, [visible]);

  if (!shouldRender) return null;

  return (
    <div
      className={`fixed inset-0 z-[100] flex items-center justify-center bg-[#FFFBF0] transition-opacity ease-out ${
        visible ? "opacity-100" : "opacity-0"
      }`}
      style={{ transitionDuration: "800ms" }}
      role="status"
      aria-label="Loading..."
    >
      <div 
        className="w-55 h-55 sm:w-63 sm:h-63"
        style={{ animation: "spin 4s linear infinite" }}
      >
        <img 
          src="/Rudraksha.png" 
          alt="Loading..." 
          className="w-full h-full object-contain drop-shadow-md" 
          style={{ mixBlendMode: "multiply" }}
        />
      </div>
    </div>
  );
};

export default LoadingScreen;
